import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CuiPanelSection } from './PanelSection';

const paddingToClassNameMap = {
  l: 'cuiPanel--paddingLarge',
};

export const PADDING = Object.keys(paddingToClassNameMap);

const colorToClassNameMap = {
  success: 'cuiPanel--success',
  highlight: 'cuiPanel--highlight',
};

export const COLORS = Object.keys(colorToClassNameMap);

const sectionTypeToKeyableMap = {
  number: true,
  string: true,
};

export const CuiPanel = ({
  children,
  sections,
  className,
  color,
  padding,
  ...rest
}) => {
  const classes = classNames(
    'cuiPanel',
    className,
    colorToClassNameMap[color],
    paddingToClassNameMap[padding]
  );

  let wrappedChildren;

  if (children) {
    wrappedChildren = <CuiPanelSection>{children}</CuiPanelSection>;
  } else if (sections) {
    wrappedChildren = sections.map(section => (
      <CuiPanelSection
        key={sectionTypeToKeyableMap[typeof section] ? section : section.key}
      >
        {section}
      </CuiPanelSection>
    ));
  }

  return (
    <div className={classes} {...rest}>
      {wrappedChildren}
    </div>
  );
};

CuiPanel.propTypes = {
  children: PropTypes.node,
  sections: PropTypes.array,
  className: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  padding: PropTypes.oneOf(PADDING),
};

CuiPanel.defaultProps = {
  children: undefined,
  sections: undefined,
  className: undefined,
  color: undefined,
  padding: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/panel/Panel.js